import {fatal} from '../../logging/fatal';
import { ABTestData } from "./ABTestData";


export { fatal } from "../../logging/fatal";
import { warn } from "../../logging/warn";
import { XML, XMLList } from "@goodgamestudios/xml-e4x";
import { ABTest } from "./ABTest";

/**
 * <p>ABTestController handles all interaction to controll A/B-Testing initalization and tracking.</p>
 *
 * @author dkoehler
 */
export class ABTestController {
    /** instance of this singleton. */
    private static _instance: ABTestController;

    /** instance of this singleton. */
    public static get instance(): ABTestController {
        if (!ABTestController._instance) {
            ABTestController._instance = new ABTestController();
        }
        return ABTestController._instance;
    }

    /** instance of this singleton. */
    private _instance: ABTestController;
    /** all tests that are defined in config-xml. */
    private enabledTests: ABTest[] = [];

    /**
     * Constructor
     */
    constructor() {
        if (ABTestController._instance) {
            throw new Error("this is a singleton. cannot instanciate more than once");
        }
    }

    /**
     * initalize this controller
     *
     * @param configXML test configuration
     * @param _gameID is of running game
     * @param _instanceID selected instamce of player
     * @param _networkID hosting network
     * @param _accountID unique account hash of this user
     * @param _playerID global id of player
     * @param _referrer url of website containing this flash-client
     *
     */
    public initialize(_configXML: XML, _gameID: number, _instanceID: number, _networkID: number, _accountID: string, _playerID: number, _referrer: string): void {
        let runningTest: XMLList = _configXML.children();

        for (let test of runningTest) {
            let testData: ABTestData = new ABTestData();
            testData._testID = Number(test.attribute("id"));
            testData.gameID = _gameID;
            testData.instanceID = _instanceID;
            testData.networkID = _networkID;
            testData.accountID = _accountID;
            testData.playerID = _playerID;
            testData.referrer = _referrer;
            this.enabledTests.push(new ABTest(testData));
        }
    }

    /**
     * get specific test
     *
     * @param _testID id of test
     * @return test, if test not available returns null
     *
     */
    public getTest(_testID: number): ABTest {
        let length: number = this.enabledTests.length;

        for (let i: number = 0; i < length; i++) {
            if (this.enabledTests[i].testData.testID == _testID) {
                return this.enabledTests[i];
            }
        }
        fatal("no test with id " + _testID + " available");
        return null;
    }

    /**
     * get global test (at the moment there will be only one test running at the same time)
     *
     * @return test, if test not available returns null
     *
     */
    public getGlobalTest(): ABTest {
        if (this.enabledTests.length > 0 && this.enabledTests[0]) {
            return this.enabledTests[0];
        }
        else {
            fatal("no test with available");
            return null;
        }
    }

    /**
     * track a conversion of a specific test
     *
     * @param testID test who sends a conversion
     * @param _userID id of current client user
     * @param _instanceID id of current instance
     * @param _referrer url of website containing this flash-client
     *
     */
    public trackConversion(_testID: number, _userID: number, _instanceID: number, _referrer: string): void {
        let length: number = this.enabledTests.length;

        for (let i: number = 0; i < length; i++) {
            if (this.enabledTests[i].testData.testID == _testID) {
                if (this.enabledTests[i].testData.isValid) {
                    this.enabledTests[i].sendConversion(_userID, _instanceID, _referrer);
                }
                else {
                    warn("ab-test with id: " + _testID + " is not valid");
                }
            }
        }
    }
}

